const genHorizontalStyle = token => {
  const {
    componentCls
  } = token;
  const stepsItemCls = `${componentCls}-item`; // .ant-steps-item
  return {
    [`${componentCls}-horizontal`]: {
      [`${stepsItemCls}-tail`]: {
        transform: 'translateY(-50%)'
      }
    }
  };
};
export default genHorizontalStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/steps/style/horizontal.js
// module id = 3608
// module chunks = 0